function if_mutator(code, ASTBlock){
    if(!code.includes("\"\"\"*if_mutator*\"\"\"")) {
        return code
    }
    let ifblocks = Object.keys(ASTBlock.values).length
    code = "if \"\"\"{{IF0}}\"\"\": \n    \"\"\"{{DO0}}\"\"\""
    for (let i = 1; i < ifblocks; i++) {
        code += `\nelif """{{IF${i}}}""": \n    """{{DO${i}}}"""`
    }
    console.log(code)
    return code
}

function alvik_get_tof_distance_mutator(code, ASTBlock) {
    if(ASTBlock.values.tof === "top_tof"){
        code.replace("get_distance", "get_distance_top")
    } else if(ASTBlock.values.tof === "bottom_tof") {
        code.replace("get_distance", "get_distance_bottom")
    }
    return code
}

let CodeMutator = {
    "if_block": if_mutator,
    "alvik_get_tof_distance": alvik_get_tof_distance_mutator
}

export default CodeMutator